import { t } from "@/i18n-js/instance";

// Backend serializers use I18n.t("no_name"); English is always included so a
// locale mismatch between server and client still matches the common case.
const ENGLISH_NO_NAME = "[No name]";

export const isNoNamePlaceholder = (name?: string | null): boolean => {
  if (!name?.trim()) return false;

  const trimmed = name.trim();
  const placeholders = new Set([ENGLISH_NO_NAME, t("no_name")]);

  for (const placeholder of placeholders) {
    if (trimmed === placeholder || trimmed.startsWith(`${placeholder} `)) {
      return true;
    }
  }

  return false;
};
